module.exports = __webpack_public_path__ + "static/media/info.36ea820e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/info.svg
// module id = 587
// module chunks = 0